import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncCoworkRoomGenerator({ ...rest }) {
  const AsyncLoad = loadable(() => import("../admin/page/CoworkRoomGenerator"));
  console.log("Loading", AsyncCoworkRoomGenerator.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncCoworkRoomGenerator;
